import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Badge } from '../models/badge.model';
import { StreakAward } from '../models/streak-award.model';
import { MedalGroup } from '../models/medal-group.model';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-certificate',
  templateUrl: './certificate.component.html',
  styleUrl: './certificate.component.scss',
  animations: [
    trigger('flipState', [
      state('back', style({
        transform: 'rotateY(179deg)'
      })),
      state('front', style({
        transform: 'rotateY(0)'
      })),
      transition('back => front', animate('500ms ease-out')),
      transition('front => back', animate('500ms ease-in'))
    ])
  ]
})
export class CertificateComponent implements OnInit {

  @Input() badge: Badge;
  @Input() streak: StreakAward;
  @Input() medal: MedalGroup;
  seed: number;
  flip: string = 'front';
  showFront: boolean;
  
  constructor(private modal: NgbActiveModal) {  
  }

  ngOnInit(): void {
    this.showFront = true;
    this.seed = new Date().getSeconds() % 3;
  }

  swish() {
    this.flip = (this.flip === 'back') ? 'front' : 'back';
    setTimeout(() => {
      this.showFront = !this.showFront;
    }, 250);
  }

  dismissModal() {
    this.modal.dismiss();
  }

  get motivationalBullshit(): string {
    switch (this.seed)
    {
      case 0: return "Congratulations!";
      case 1: return "Amazing Stuff!";
      default: return "You're a Winner!";
    }
  }

  get streakDuration(): string {
    return this.getStreakDurationText(this.streak.awardedCount);
  }

  get longestStreakDuration(): string {
    if (this.streak.bestAwardedCount > this.streak.awardedCount) {
      return `Your longest streak was: ${this.getStreakDurationText(this.streak.bestAwardedCount)}`;
    } else if (this.streak.isAwarded) {
      return `You're on a streak!`;
    } else {
      return '';
    }
  }

  getStreakDurationText(awardedCount: number): string {
    let interval = '';
    if (this.streak.evaluationInterval === 0) {
      interval = awardedCount === 1 ? 'Day' : 'Days';
    } else {
      interval = awardedCount === 1 ? 'Week' : 'Weeks';
    }
    if (awardedCount > 0) {
      return `${awardedCount} ${interval}`;
    }
    return '';
  }
}
